var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"block origin-top-right absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-md border py-2 z-10 transition duration-300 animate-in slide-in-from-top-3"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }